<template>
  <view class="checkbox" wx:class="{{isChecked && 'checked'}}" catchtap="toggleCheck">
    <view class="checkbox-inner" wx:class="{{isChecked && 'checked'}}"></view>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'

createComponent({
  props: {
    checkedProp: {
      type: Boolean,
      optionalTypes: [Number, String, Array],
      value: true
    },
    disabled: {
      type: Boolean,
      value: false
    },
    checkboxKey: {
      type: String,
      optionalTypes: [Number],
      value: ''
    }
  },
  computed: {
    isChecked() {
      const checked = this.isPropsArray
        ? this.checkedProp.indexOf(this.checkboxKey) > -1
        : this.checkedProp === this.checkboxKey
      return checked
    },
    isPropsArray() {
      return Array.isArray(this.checkedProp)
    }
  },
  data: {},
  methods: {
    toggleCheck() {
      if (this.disabled) return this.triggerEvent('disableClick')
      const value = this.checkboxKey
      this.triggerEvent('checkedChange', { value: value })
    }
  }
})
</script>

<style scoped lang="stylus">
.checkbox
  width 18px
  height 18px
  position relative
  border-radius 6px
  background #FFFFFF
  border 1px solid #D4D3D3
  box-sizing border-box
  cursor pointer
  transition border 0.3s ease
  -webkit-tap-highlight-color transparent
  -moz-tap-highlight-color transparent
  overflow hidden
  &.checked
    background-color #FF6400
    border none
  &-inner
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%) scale(0)
    background-image url('https://ut-static.udache.com/webx/sfc/umPNV4UERO7bfybj8SSpI.png')
    background-size cover
    width 8.5px
    height 6px
    transition transform 0.3s ease
    &.checked
      transform translate(-50%, -50%) scale(1)
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {}
}
</script>